
function getDealeasyApiVersion() {
  return window.dealeasyPublicApiVersion || '2026-04';
}

async function GetDiscountsDealeasy(settings){
  const n_Headers = new Headers();
  n_Headers.append("X-Shopify-Storefront-Access-Token", window.dealeasyPublicAccessToken);
  n_Headers.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    "query": "query metaobjects($type: String!, $key: String!) { metaobjects(type: $type, first: 250) { nodes { field(key: $key) { value } } }}",
    "variables": {
      "type": "$app:dealeasy-vds",
      "key": "discount"
    }
  });

  const requestOptions = {
    method: "POST",
    headers: n_Headers,
    body: raw,
    redirect: "follow"
  };

  return fetch(`/api/${getDealeasyApiVersion()}/graphql.json`, requestOptions)
  .then((response) => response.json())
  .then((result) => {
   
    const discounts = result.data.metaobjects.nodes;
    const discounts_v = [];
    discounts.forEach((discount)=>{
      var discount_v = JSON.parse(discount.field.value);
      if(discount_v.status == 'ACTIVE' && discount_v.discountType == 'AUTOMATIC_DISCOUNT' ){
        var discount_metafields = discount_v.metafields.filter((metafield)=>{
         if(metafield.key == 'lb-dealeasy-config' && metafield.type == 'json'){
           var metafield_v = JSON.parse(metafield.value);
           if(metafield_v.widgetType == settings.widgetType){
             discount_v.metafield_discount_v = metafield_v;
             return true;
           }else{
             return false;
           }
         }
        })
        if(discount_metafields.length > 0){
          discounts_v.push(discount_v);
        }
      }
    })
    return(discounts_v)
  })
  .catch((error) => console.error(error));
  
}

async function GetSetupsDealeasy(settings){
  const n_Headers = new Headers();
  n_Headers.append("X-Shopify-Storefront-Access-Token", window.dealeasyPublicAccessToken);
  n_Headers.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    "query": "query moSetups($type: String!, $key: String!) @inContext(country: AT){ metaobjects(type:  $type, first: 250) { nodes { field(key: $key) { value } } } }",
    "variables": {
      "type": "$app:dealeasy-vdSetups",
      "key": "setup"
    }
  });

  const requestOptions = {
    method: "POST",
    headers: n_Headers,
    body: raw,
    redirect: "follow"
  };

  return fetch(`/api/${getDealeasyApiVersion()}/graphql.json`, requestOptions)
  .then((response) => response.json())
  .then((result) => {
    const setups = result.data.metaobjects.nodes;
    const setups_v = [];

     setups.forEach((setup)=>{
      var setup_v = JSON.parse(setup.field.value);
       if(setup_v.recordType == settings.widgetType){
         setups_v.push(setup_v);
       }
     });

    return(setups_v);
  })
  .catch((error) => console.error(error));
  
}

async function RenderDiscountsDealeasy_VDcards(props){

  const settings = JSON.parse(document.querySelector("#"+props.product_form_id+"_bundle_data").textContent)
  let content_block = document.querySelector(settings.content_selector);
  
  var product_form = document.querySelector("#"+settings.product_form_id);
  if(!Boolean(product_form)){
    product_form = content_block.closest('form');
  }
  
  const product_quantity_inputs = document.querySelectorAll( '#'+settings.product_form_id+' input[name="quantity"], input[name="quantity"][form="'+settings.product_form_id+'"], #'+product_form.getAttribute("id")+' input[name="quantity"], input[name="quantity"][form="'+product_form.getAttribute("id")+'"]' );
  const product_bundle_quantity_inputs = document.querySelectorAll( 'input[name="items[1][quantity]"][form="'+settings.product_form_id+'"]' );
  const product_bundle_id_inputs = document.querySelectorAll( 'input[name="items[1][id]"][form="'+settings.product_form_id+'"]' );

  product_bundle_quantity_inputs.forEach((item)=>{
    item.setAttribute("form", product_form.getAttribute("id"));
  })

  product_bundle_id_inputs.forEach((item)=>{
    item.setAttribute("form", product_form.getAttribute("id"));
  })
  
  
  
  GetDiscountsDealeasy({
    widgetType: 'widget#vdcards'
  }).then(async (data)=>{

    const setups = await GetSetupsDealeasy({
      widgetType: 'widget#vdcards'
    });
    
    data.forEach((discount)=>{
      if(discount.metafield_discount_v.selectedProductIds.includes('gid://shopify/Product/'+settings.product_id)){
        content_block.style.display = 'block';
        discount.metafields.forEach((metafield)=>{
          if(metafield.key == "dealeasy-translations" && metafield.type == 'json'){
            var metafield_v = JSON.parse(metafield.value);
            discount.metafield_translations_v = metafield_v;
          }
        })

        if(discount.metafield_translations_v){
          const newTitle = document.createElement("div");
          newTitle.classList.add('DS_content_title');
          newTitle.innerHTML = `<span> `+discount.metafield_translations_v.default.promotionText+` </span>`
          content_block.append(newTitle);
        }
        
        discount.metafield_discount_v.tiers.push({
          quantity: 1,
          value: 0,
          isDefault: false,
          highlight: 'NONE'
        })

        function compare( a, b ) {
          if ( a.quantity < b.quantity ){
            return -1;
          }
          if ( a.quantity > b.quantity ){
            return 1;
          }
          return 0;
        }
        
        discount.metafield_discount_v.tiers.sort( compare );
        
        const newWrapper = document.createElement("div");
        newWrapper.classList.add('DS_content_wrapper');

        if(discount.metafield_discount_v.tiers.length > 0){
          const qty_wrap = document.querySelector('.product__block.product__form__wrapper .selector-wrapper--qty');
          if(Boolean(qty_wrap)){
            qty_wrap.style.display = 'none';
          }
          
        }

        const moneyFormat = window.theme.moneyFormat.replace("{{amount_with_comma_separator}}", "{{amount}}");
        
        discount.metafield_discount_v.tiers.forEach((tier)=>{
          var selling_plan = null;

          if(product_form.selling_plan){
            if(product_form.selling_plan.checked){
               selling_plan = product_form.selling_plan.value;
             }
          }
            var selling_plan_allocation = null;
            if(selling_plan){
              var selling_plan_allocation = settings.current_variant.selling_plan_allocations.filter((sell_plan)=>{
                if(Number(sell_plan.selling_plan_id) == Number(selling_plan)){
                  return true;
                }else{
                  return false;
                }
              })[0];
            }

          var price_orig = tier.quantity * (settings.current_variant.price / 100) ;
          var price_disc = tier.quantity * ((settings.current_variant.price / 100) - ((settings.current_variant.price / 100) * (tier.value / 100 )));
         

          // if(selling_plan_allocation){
          //   price_disc = tier.quantity * (selling_plan_allocation.price / 100) ;
          // }
          
          var price_saved = price_orig - price_disc;
          
          const newSelectorTier = document.createElement("div");
          newSelectorTier.classList.add('DS_content_tier');

          var price_orig_text = '';
          if(price_orig != price_disc){
            var price_orig_text = moneyFormat.replace("{{amount}}", price_orig.toFixed(2));
          }
          var price_disc_text = moneyFormat.replace("{{amount}}", price_disc.toFixed(2));

          
          
          var highlight_text = '';
          if(tier.highlight !== 'NONE'){
            if(tier.highlight == 'MOST_POPULAR'){
              highlight_text = `
              <div class="DS_content_tier-selector_highlight">
                <span>` +setups[0].translations.default.popularOptionText+ `</span>
              </div>`;
            }
            newSelectorTier.classList.add('DS_content_tier_hashighlight');
          }
          var input = '';
          if(tier.isDefault){
            input = `<input type="radio" value="`+tier.quantity+`" class="DS_content_tier-selector_input_radio" name="LB-selector-count-tier" >`;
              // product_quantity_inputs.forEach((input_q)=>{
              //   input_q.value = tier.quantity;
              //   input_q.dispatchEvent(new Event('change'));
              //   input_q.dispatchEvent(new Event('input'));
              //   console.log(input_q.value, tier.quantity)
              // })
          }else{
            input = `<input type="radio" value="`+tier.quantity+`" class="DS_content_tier-selector_input_radio" name="LB-selector-count-tier">`
          }

          var quantity_text = '';
          if(tier.quantity){
            quantity_text = setups[0].translations.default.quantityText.replace("{{product_quantity}}", tier.quantity);
          }

          var discount_text = '';
          if(tier.value > 0){
            discount_text = setups[0].translations.default.discountText.replace("{{discount}}", tier.value);
          }else{
            discount_text = setups[0].translations.default.standardPriceHelpText
          }

          var discount_saved_text = '';
          if(price_saved > 0){
            discount_saved_text = moneyFormat.replace("{{amount}}", price_saved.toFixed(2));
            discount_saved_text = '<span class="bold money">'+discount_saved_text+'</span>'
            discount_saved_text = setups[0].translations.default.savedPriceText.replace("{{saved_price}}", discount_saved_text);
          }
          
          newSelectorTier.innerHTML = `
            <div class="DS_content_tier-selector" data-discount-percent="`+tier.value+`" data-discount-quantity="`+tier.quantity+`">
            `+highlight_text+`
            <div class="DS_content_tier-selector_wrapper">
              <div class="DS_content_tier-selector_input">
                `+input+`
              </div>
              <div class="DS_content_tier-selector_QuantityText">
                <span class="">`+ quantity_text +`</span>
              </div>
              <div class="DS_content_tier-selector_PriceText">
                <span class="DS_content_tier-selector_PriceOriginal money">`+ price_orig_text +`</span>
                <span class="DS_content_tier-selector_PriceDiscounted money">`+ price_disc_text +`</span>
              </div>
            </div>
            <div class="DS_content_tier-selector_wrapper">
              <div class="DS_content_tier-selector_DiscountText">
              `+discount_text+`
              </div>
              <div class="DS_content_tier-selector_DiscountSavedText">
              `+discount_saved_text+`
              </div>
            </div>
            </div>
          `;

          window.addEventListener('theme:variant:change', (event) => {
            const variant = event.detail.variant;
            var selling_plan = null;

            if(selling_plan){
              product_quantity_inputs.forEach((input_q)=>{
                input_q.value = 1;
                input_q.dispatchEvent(new Event('change'));
                input_q.dispatchEvent(new Event('input'));
              })
            }
            
             setTimeout(()=>{
              const params = new URLSearchParams(document.location.search);
              selling_plan = params.get('selling_plan');
              var selling_plan_allocation = null;
              if(selling_plan){
                var selling_plan_allocation = variant.selling_plan_allocations.filter((sell_plan)=>{
                  if(Number(sell_plan.selling_plan_id) == Number(selling_plan)){
                    return true;
                  }else{
                    return false;
                  }
                })[0];
              }
 
            var price_orig = tier.quantity * (variant.price / 100) ;
            var price_disc = tier.quantity * ((variant.price / 100) - ((variant.price / 100) * (tier.value / 100 )));
            
              
           // if(selling_plan_allocation){
           //   price_disc = tier.quantity * (selling_plan_allocation.price / 100);
           // }

              var price_saved = price_orig - price_disc;
            var price_orig_text = '';
            if(price_orig != price_disc){
            var price_orig_text = moneyFormat.replace("{{amount}}", price_orig.toFixed(2));
            }
            newSelectorTier.querySelector('.DS_content_tier-selector_PriceText span.DS_content_tier-selector_PriceOriginal.money').innerHTML = price_orig_text;
              
            var price_disc_text = moneyFormat.replace("{{amount}}", price_disc.toFixed(2));
            newSelectorTier.querySelector('.DS_content_tier-selector_PriceText span.DS_content_tier-selector_PriceDiscounted.money').innerHTML = price_disc_text;

            var discount_saved_text = '';
              if(price_saved > 0){
                discount_saved_text = moneyFormat.replace("{{amount}}", price_saved.toFixed(2));
                discount_saved_text = '<span class="bold money">'+discount_saved_text+'</span>'
                discount_saved_text = setups[0].translations.default.savedPriceText.replace("{{saved_price}}", discount_saved_text);
              }
              newSelectorTier.querySelector('.DS_content_tier-selector_DiscountSavedText').innerHTML = discount_saved_text;
               
              }, 100)
          });

          newSelectorTier.querySelector('.DS_content_tier-selector_input input').addEventListener('change', (event)=>{
            if(product_form.selling_plan){
              if(product_form.selling_plan.checked){
                 var selling_plan = product_form.selling_plan.value;
               }
            }
            
            if(Boolean(selling_plan) && Boolean(event.target.checked)){
              var q_bund_value = Number(event.target.value);
              var q_value = 1;
            }else if(!Boolean(selling_plan) && Boolean(event.target.checked)){
              var q_bund_value = 0;
              var q_value = Number(event.target.value);
            }else if(!Boolean(selling_plan) && !Boolean(event.target.checked)){
              var q_bund_value = 0;
              var q_value = 1;
            }else if(Boolean(selling_plan) && !Boolean(event.target.checked)){
              var q_bund_value = 0;
              var q_value = 1;
            }

            console.log(q_bund_value, q_value)

            product_quantity_inputs.forEach((input_q)=>{
                input_q.value = q_value;
                input_q.dispatchEvent(new Event('change'));
                input_q.dispatchEvent(new Event('input'));
              })
            product_bundle_quantity_inputs.forEach((input_q)=>{
              input_q.value = q_bund_value;
              input_q.dispatchEvent(new Event('change'));
              input_q.dispatchEvent(new Event('input'));
            })
            
            
          })

          newSelectorTier.addEventListener('click', (event)=>{
            const selectInput = newSelectorTier.querySelector('.DS_content_tier-selector_input input');
            if(selectInput.checked == true){
              selectInput.checked = false;
              selectInput.dispatchEvent(new Event('change'));
            }else{
              selectInput.checked = true;
              selectInput.dispatchEvent(new Event('change'));
            }
            
          });

          

          newWrapper.append(newSelectorTier);
          
        })

          window.addEventListener('theme:variant:change', (event) => {
             setTimeout(()=>{
            // const params = new URLSearchParams(document.location.search);
            // var selling_plan = params.get('selling_plan');
          if(product_form.selling_plan){
            if(product_form.selling_plan.checked){
               var selling_plan = product_form.selling_plan.value;
             }
          }
           
            const selectInput = document.querySelector('.DS_content_tier-selector_input input:checked');

            if(Boolean(selling_plan) && Boolean(selectInput)){
              var q_bund_value = Number(selectInput.value);
              var q_value = 1;
            }else if(!Boolean(selling_plan) && Boolean(selectInput)){
              var q_bund_value = 0;
              var q_value = Number(selectInput.value);
            }else if(!Boolean(selling_plan) && !Boolean(selectInput)){
              var q_bund_value = 0;
              var q_value = 1;
            }else if(Boolean(selling_plan) && !Boolean(selectInput)){
              var q_bund_value = 0;
              var q_value = 1;
            }

            console.log(q_bund_value, q_value)

            product_quantity_inputs.forEach((input_q)=>{
                input_q.value = q_value;
                input_q.dispatchEvent(new Event('change'));
                input_q.dispatchEvent(new Event('input'));
              })
            product_bundle_quantity_inputs.forEach((input_q)=>{
              input_q.value = q_bund_value;
              input_q.dispatchEvent(new Event('change'));
              input_q.dispatchEvent(new Event('input'));
            })
               
            }, 100)
          })
        
        content_block.append(newWrapper);

          window.addEventListener('theme:variant:change', (event) => {
          const variant = event.detail.variant;
          const product_id_input = content_block.querySelector( 'input[name="items[1][id]"]' );
          product_id_input.value = variant.id;
          product_id_input.dispatchEvent(new Event('change'));
          product_id_input.dispatchEvent(new Event('input'));
        })

      }
    })
    
  });

 
  
}

